export default {
  title: "恶意地址风险监控",
  subtitle: "最近24小时涉案地址转账信息",
  viewMore: "查看更多",
  statistics: {
    associatedAddresses: "关联地址数",
    totalTransactions: "转入总交易",
    totalAmount: "转入总数量",
  },
};
